import Vue from "vue";
import OutdatedBrowser from "outdated-browser-rework";
import jQuery from "jquery";

// import AnalyticsHelper from "@Scripts/Common/AnalyticsHelper";

import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";

export default class BasePage {
    public static async init() {
		await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);
            
            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        AppConfig.AddComponents();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.resetCssAnimations();
        this.zombieBrowsers();
        // this.setAnalytics();
        this.setFancyBox();
        this.setHeader();
        this.setShareButton();
        this.setResponsive();
    }

    private static resetCssAnimations() {
        // Styles animations reset
        (<any>window).addEventListener("load", function () {
            let loaders = document.getElementsByClassName("loader-box");
            for (let i = 0; i < loaders.length; i++) {
                loaders[i].classList.add("hide");
            }

            let preLoaders = document.querySelectorAll("[data-preload]");
            for (let i = 0; i < preLoaders.length; i++) {
                preLoaders[i].removeAttribute("data-preload");
            }
        });
    }

    private static zombieBrowsers() {
        OutdatedBrowser({
            browserSupport: {
                "IE": false
            },
            bgColor: "#E18300",
            color: "#ffffff",
            isUnknownBrowserOK: true
        });
    }

    // private static setAnalytics() {
    //     jQuery.scrollDepth({
    //         userTiming: false,
    //         pixelDepth: false,
    //         nonInteraction: false,
    //     });

    //     var gaEventItems = document.querySelectorAll("[data-gaevent=\"true\"]");
    //     if (gaEventItems && gaEventItems.length != 0) {
    //         for (let i = 0; i < gaEventItems.length; i++) {
    //             gaEventItems[i].addEventListener("click", function () {
    //                 AnalyticsHelper.sendEvent(gaEventItems[i].getAttribute("data-gacategory"), gaEventItems[i].getAttribute("data-gaaction"), gaEventItems[i].getAttribute("data-galabel"));
    //             });
    //         }
    //     }

    //     var gaEventEditorItems = document.querySelectorAll(".editor a");
    //     if (gaEventEditorItems && gaEventEditorItems.length != 0) {
    //         for (let i = 0; i < gaEventEditorItems.length; i++) {
    //             gaEventEditorItems[i].addEventListener("click", function () {
    //                 AnalyticsHelper.sendEvent("Page", "Click", gaEventEditorItems[i].getAttribute("href"));
    //             });
    //         }
    //     }
    // }

    private static setFancyBox() {
        jQuery("[data-fancybox]").fancybox({
            buttons: [
                "close"
            ]
        });

        jQuery("[data-fancybox=\"nl\"]").fancybox({
            baseClass: "fncy-nl"
        });

        jQuery("[data-fancybox=\"info\"]").fancybox({
            baseClass: "fncy-info"
        });

        jQuery(".close-fancy").click(function () {
            (<any>parent).jQuery.fancybox.close(true);
        });
    }

    private static setHeader() {
        var header = jQuery(".app-header");

        if (jQuery(<any>window).scrollTop() > 0) {
            header.attr("data-minify", "");
        }

        jQuery(<any>window).scroll(function () {
            if (jQuery(window).scrollTop() > 0) {
                header.attr("data-minify", "");
            } else {
                header.removeAttr("data-minify");
            }
        });
    }

    private static setShareButton() {
        let openShare = document.getElementById("OpenShare");
        let shareBox = document.getElementById("ShareBox");

        if (openShare) {
            openShare.addEventListener("click", function () {
                shareBox.classList.toggle("show");
            });
        }
    }

    private static setResponsive() {
        let wrapTap = document.getElementById("WrapTap"),
            openMenuButton = document.getElementById("OpenMenuButton"),
            menuBox = document.getElementById("MenuBox");


        if (openMenuButton) {
            openMenuButton.addEventListener("click", function () {
                menuBox.classList.add("show");
                wrapTap.classList.add("show");
            });
        }

        if (wrapTap) {
            wrapTap.addEventListener("click", function () {
                menuBox.classList.remove("show");
                wrapTap.classList.remove("show");
                wrapTap.classList.remove("white");
            });
        }

        let categories = document.querySelectorAll("[data-open]"),
            subCategoriesList = document.querySelectorAll("[data-list]"),
            subCategoriesBackButton = document.querySelectorAll("[data-back]");
        for (let i = 0; i < categories.length; i++) {
            categories[i].addEventListener("click", function () {
                subCategoriesList[i].classList.add("show");
            });

            subCategoriesBackButton[i].addEventListener("click", function () {
                subCategoriesList[i].classList.remove("show");
            });

            wrapTap.addEventListener("click", function () {
                subCategoriesList[i].classList.remove("show");
            });
        }
    }
}